import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useWizardManager from '@hooks/useWizardManager'
import { useConfig } from '@context/ConfigurationContext'
import routes from 'src/config/routes'
import { completedPractitioner, seenPractitioner } from 'src/services/analytics'
import { PractitionerScreen } from '@screens/PractitionerScreen/PractitionerScreen'
import { usePractitionersContext } from '@context/PractitionersContext'
import { useSelectPreferredPractitioner } from '@hooks/useSelectPreferredPractitioner'
import { useVerifyPhoneContext } from '@context/VerifyPhoneContext'

const Practitioner = () => {
  useWizardManager({
    targetRoute: routes.practitioner,
    onValidStep: () => seenPractitioner(),
  })
  const { t } = useTranslation()
  const { nonModalEmbed } = useConfig()
  const history = useHistory()
  const { selectedPatient } = useVerifyPhoneContext()
  const selectPreferredPractitioners = useSelectPreferredPractitioner({
    clearSelectedSlot: false,
    possibleToSetAll: true,
  })

  const { allPractitioners, isLoading } = usePractitionersContext()
  const noPractitionersError =
    allPractitioners?.length === 0 && !isLoading ? t('errors.no_availabilities_for_the_next_30_days') : ''

  const handleBackClicked = () => {
    history.push(routes.appointment)
  }
  const handleNextClicked = (selectedPractitionerIds: string[]) => {
    selectPreferredPractitioners(selectedPractitionerIds, selectedPatient?.patientReferenceId)
    completedPractitioner()
    history.push(routes.appointment)
  }

  return (
    <PractitionerScreen
      practitioners={allPractitioners}
      onBackClicked={handleBackClicked}
      onNextClicked={handleNextClicked}
      loading={isLoading}
      error={noPractitionersError}
      nonModalEmbed={nonModalEmbed}
    />
  )
}

export default Practitioner
